<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PageBase from "@common/PageBase";
    import VueCqrs from "@cqrs/vue-component-cqrs";
    import VuePageQueries from "@Organizations/Users/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/commands-vue-component";

    @Component({
        watch: {
            userSessionDetails: 'userSessionDetailsChanged'
        }
    })
    export default class AccountPage extends mixins(PageBase, VueCqrs, VuePageQueries, VuePageCommands) {
        get userSessionDetails() { return this.model?.UserSessionDetails; }
        get userId() { return this.userSessionDetails?.UserId; }
        get currentSessionId() { return this.userSessionDetails?.CurrentSessionId; }

        mounted() {
            document.title = "TransparentChoice account";
            this.runCurrentUserQueryV1(false, false, false);
        }

        //@Watch('userSessionDetails')
        userSessionDetailsChanged(userSessionDetails) {
            if (userSessionDetails.UserId == 0) {
                this.navigateTo('/#/');
            }
        }

        handleResetPassword() {
            if (confirm('Do you really want to reset your password?')) {
                this.invokeResetPasswordCommandV1(this.userId, null);
            }
        }

        handleSignoutFromAllSessionsCommandV1() {
            this.invokeSignoutFromAllSessionsCommandV1(this.userId);
        }

        succeedSignoutFromAllSessionsCommandV1() {
            location.href = '/#/signin';
        }

        handleSignoutFromSessionCommandV1() {
            this.invokeSignoutFromSessionCommandV1(this.userId, this.currentSessionId);
        }

        succeedSignoutFromSessionCommandV1() {
            location.href = '/#/signin';
        }
    }
</script>

<template>
    <div>
        <button @click="$router.go(-1)" type="button" class="btn btn-lg btn-link">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            <span>Back</span>
        </button>

        <div style="min-width: 400px; width: 40vw; margin: auto; margin-top: 40px;">
            <h2 class="fg-color-blue">{{userSessionDetails?.DisplayName}}</h2>

            <div>
                <span>Organization:</span>
                <strong v-if="userSessionDetails.OrganizationUnitId" class="fg-color-gray">
                    {{userSessionDetails?.OrganizationUnitName}}
                </strong>
                <strong v-else-if="userSessionDetails.IsGlobalAdmin">
                    <a :href="`/#/admin/organizations/users/manage/organization/${userSessionDetails.UserId}`">None</a>
                </strong>
                <strong v-else>None</strong>
            </div>

            <div>
                <span>Email:</span>
                <strong class="fg-color-gray">{{userSessionDetails.Email}}</strong>
            </div>

            <hr /><br />

            <div class="border-box">
                <h4>My password</h4>
                <p style="font-size: 16px;">You can change password by providing your one or reset it to let us generate one for you and send it to your email</p>
                <a type="button" class="btn btn-primary" href="/#/organizations/users/changepassword">Change password</a>
                <button type="button" class="btn btn-secondary" @click="handleResetPassword">Reset password</button>
            </div>

            <div class="border-box">
                <h4>My sign-ins</h4>
                <p style="font-size: 16px;">Do you want do sign-out just from the current session or also from all other sessions on all other devices and browsers?</p>
                <button type="button" class="btn btn-primary" @click="handleSignoutFromSessionCommandV1">Current session</button>
                <button type="button" class="btn btn-secondary" @click="handleSignoutFromAllSessionsCommandV1">All my sessions</button>
            </div>

            <div class="border-box">
                <h4>Access tokens</h4>
                <p style="font-size: 16px;">Manage your tokens for  API calls</p>
                <a role="button" class="btn btn-primary" href="/#/organizations/accesstokens/my">My tokens</a>
            </div>
        </div>
    </div>
</template>